module.exports = __webpack_public_path__ + "static/img/box-bg.3b95c935.png";